import { render, staticRenderFns } from "./shipmentRequest.vue?vue&type=template&id=3ce5ab21&scoped=true"
import script from "./shipmentRequest.vue?vue&type=script&lang=js"
export * from "./shipmentRequest.vue?vue&type=script&lang=js"
import style0 from "./shipmentRequest.vue?vue&type=style&index=0&id=3ce5ab21&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce5ab21",
  null
  
)

export default component.exports